"use client";
import * as React from "react";
import {
  AppBar,
  Box,
  Container,
  CssBaseline,
  Divider,
  IconButton,
  Toolbar,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemText,
  Link as MUILink,
  Chip,
  Paper,
  Stack,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MenuIcon from "@mui/icons-material/Menu";
import { ThemeProvider, createTheme } from "@mui/material/styles";

// Material Design 3 (M3) style theme
const theme = createTheme({
  palette: {
    primary: { main: "#6750A4" },
    secondary: { main: "#625B71" },
    background: { default: "#FFFBFE" },
  },
  shape: { borderRadius: 16 },
  typography: {
    fontFamily: [
      "Inter",
      "system-ui",
      "-apple-system",
      "Segoe UI",
      "Roboto",
      "Ubuntu",
      "Cantarell",
      "Noto Sans",
      "Helvetica Neue",
      "Arial",
      "sans-serif",
    ].join(","),
    h1: { fontWeight: 700, letterSpacing: -0.5 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 700 },
  },
});

function Section({ title, children, defaultExpanded = false }) {
  return (
    <Accordion defaultExpanded={defaultExpanded} elevation={0} sx={{
      bgcolor: "transparent",
      border: "1px solid",
      borderColor: "divider",
      borderRadius: 2,
    }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6" fontWeight={700}>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Stack spacing={1.25}>{children}</Stack>
      </AccordionDetails>
    </Accordion>
  );
}

export default function Aboutus() {

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppBar position="sticky" color="primary" enableColorOnDark>
        <Toolbar>
          {/* <IconButton size="large" edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }}>
            <MenuIcon />
          </IconButton> */}
          <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 700 }}>
            Poster Guru — About us
          </Typography>
          <Button href="#contact" variant="outlined" color="inherit">
            Contact
          </Button>
        </Toolbar>
      </AppBar>

      <Box component="main" sx={{ py: { xs: 4, md: 8 } }}>
        <Container maxWidth="md">
          <Paper elevation={0} sx={{ p: { xs: 3, md: 5 }, borderRadius: 4, border: "1px solid", borderColor: "divider" }}>
            <Stack spacing={3}>
              <Box>
                <Typography variant="h3" gutterBottom>
                About Us
                </Typography>
                <Typography variant="body1" color="text.secondary">
                Welcome to <strong>Poster Guru</strong>, the all-in-one poster-making app designed to make creativity simple, fun, and accessible to everyone.

In today’s fast-moving world, posters are one of the most powerful ways to grab attention, share ideas, promote businesses, and express creativity. But not everyone has the time, skills, or expensive tools to create professional-quality designs. That’s where Poster Guru comes in.
                </Typography>
              </Box>

              <Divider />

              <Section title="Who We Are" defaultExpanded>
                <Typography>
                Poster Guru is built for dreamers, creators, and everyday people who want to communicate visually without struggling with complicated design software. Whether you’re a student preparing for a project, a shop owner promoting your offers, an event planner designing invitations, or just someone who wants to share beautiful messages with friends, Poster Guru gives you the tools to bring your vision to life.
                </Typography>
              </Section>

              <Section title="What We Do" defaultExpanded>

                <Typography>
                Our app offers a wide collection of ready-made templates designed by professionals. With just a few taps, you can customize posters by adding your own text, photos, logos, and colors. You don’t need design skills – Poster Guru makes the process so simple that anyone can create eye-catching, professional designs in minutes.
                </Typography>


                <List dense>
                  <ListItem>
                    <ListItemText
                     secondary="A growing library of stylish and modern templates." 
                  />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                     secondary="Easy customisation – change fonts, colours, and layouts." 
                  />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                     secondary="Add your own images, logos, and personal touch." 
                  />
                  </ListItem>

                  <ListItem>
                    <ListItemText
                     secondary="Download your poster instantly in high quality." 
                  />
                  </ListItem>

                  <ListItem>
                    <ListItemText
                     secondary="Perfect for business promotions, events, education, social media, and personal use." 
                  />
                  </ListItem>

                   
                 
                </List>

              </Section>

              <Section title="Our Mission">
                <Typography>
                At <strong>Poster Guru</strong>, our mission is to empower creativity for everyone. We believe that design should not be limited to professionals – it should be open, easy, and enjoyable for all. We are here to make poster creation stress-free and inspiring, so you can focus on expressing your ideas and making an impact.
                </Typography>
                
              </Section>

              <Section title="Why Choose Poster Guru?">
                <Typography>
                Unlike traditional design tools that are complex and time-consuming, Poster Guru is lightweight, user-friendly, and smartly designed for mobile users. You don’t need a computer or expensive software – everything is right in your pocket.
                </Typography>

                <List dense>
                  <ListItem>
                    <ListItemText 
                    primary="Simplicity – No learning curve, just start creating." 
                     />
                    </ListItem>


                    <ListItem>
                    <ListItemText 
                    primary="Creativity – Explore endless design possibilities." 
                     />
                    </ListItem>

                    <ListItem>
                    <ListItemText 
                    primary="Accessibility – Professional designs for everyone, everywhere." 
                     />
                    </ListItem>

                    <ListItem>
                    <ListItemText 
                    primary="Speed – From idea to finished poster in just a few minutes." 
                     />
                    </ListItem>
                </List>

              </Section>
             

              <Section title="The Future of Creativity">
                <Typography>
                We’re continuously improving Poster Guru with new features, smarter tools, and an expanding design library. Our goal is to help millions of people express themselves visually – whether that’s growing a business, sharing a social message, celebrating special moments, or just having fun with design.

With Poster Guru, your imagination has no limits.
                </Typography>
              </Section>

               

              <Section title="12. Contact Us" defaultExpanded>
                <Typography id="contact">
                  If you have questions or requests regarding privacy, contact us: JPK Enterprise
                </Typography>
                <List>
                  <ListItem>
                    <ListItemText
                      primary="Email"
                      secondary={<MUILink href="mailto:erkrkanhaiya@gmail.com">erkrkanhaiya@gmail.com</MUILink>}
                    />
                  </ListItem>

                  <ListItem>
                    <ListItemText
                      primary="Phone"
                      secondary='+91 95297 41079'
                    />
                  </ListItem>
                  
                  {/* <ListItem>
                    <ListItemText primary="Website" secondary={<MUILink href="https://www.posterguru.app" target="_blank" rel="noreferrer">www.posterguru.app</MUILink>} />
                  </ListItem> */}
                  <ListItem>
                    <ListItemText primary="Address" secondary="Opp.BIADA main Gate Sugar factory raod Banmankhi Bazar, Purnia 854202" />
                  </ListItem>
                </List>
              </Section>

              <Box>
                <Divider sx={{ my: 2 }} />
                <Typography variant="caption" color="text.secondary" display="block">
                  ✨ Poster Guru – Turn your ideas into posters that inspire, engage, and leave a lasting impression.
                </Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  display="block"
                  fontWeight={700}
                  marginTop={2}
                  fontSize={18}
                >
                     ✨ Poster Guru is powered by JPK Enterprise. All rights reserved © JPK Enterprise.
                </Typography>
              </Box>
            </Stack>
          </Paper>
        </Container>
      </Box>
    </ThemeProvider>
  );
}
